import Vue from 'vue'
/**
 * 获取菜单列表
 */
export function getMenuList() {
    return [{
            name: "数据概览",
            path: "realdata",
            icon: require("../img/sssj.png"),
            icon1: require("../img/sssj1.png"),
            children: [],
        },
        {
            name: "审核操作",
            path: "auditoperation",
            icon: require("../img/sh1.png"),
            icon1: require("../img/sh.png"),
            children: []
        },
        {
            name: "信息表单",
            path: "registration",
            icon: require("../img/rg1.png"),
            icon1: require("../img/rg.png"),
            children: []
        },
        {
            name: "权限管理",
            path: "authority",
            icon: require("../img/qx1.png"),
            icon1: require("../img/qx.png"),
            children: []
        },
        {
            name: "设置",
            path: "setting",
            icon: require("../img/sz1.png"),
            icon1: require("../img/sz.png"),
            children: []
        },
    ]
}

/**
 * 匹配菜单权限
 * @param {*} roleList  后台返回的权限数据
 */
export function foramtMenuByRole(roleList) {
    let menuList = getMenuList() // 菜单全集

    let menuArray = []

    menuList.forEach(menu => {
        roleList.forEach(auth => {
            if (auth.name == menu.name && (auth.authority == "1" || auth.authority == 1)) {
                menuArray.push(menu)
            }
        });
    });
    return menuArray
}
/**
 * 格式化搜索框值
 * @param {*} array 
 */
// export function initSearchData(array) {
//     let searchData = {}
//     array.forEach(element => {
//         Vue.set(searchData, element.key, element.value)
//     });
//     return searchData
// }

/**
 * 格式化dialogData
 * @param {*} array
 */
export function formatDialogData(array) {
    let returnData = { flag: true, data: {} }
    array.forEach(element => {
        if (element.notNull && element.value == "") {
            returnData.flag = false
            returnData.data = {
                msg: element.title + "不可为空!"
            }
            return returnData
        }
        Vue.set(returnData.data, element.key, element.value)
    });
    return returnData
}